import React from 'react';

import SharedCheckBoxInput from '../shared/CheckBoxInput';

import {
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
  addMissingMandatoryField,
  removeMissingMandatoryField,
} from 'reducers/autoPersonalFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface AutoCheckBoxInputProps {
  section: number;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  onChange?: (event: any) => void;
  children?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  label?: string;
  isChecked?: boolean;
  [x: string]: any;
}

const AutoCheckBoxInput = (props: AutoCheckBoxInputProps) => {
  const formActions = {
    addRemark,
    removeRemark,
    updateRemark,
    addFile,
    removeFile,
    addMissingMandatoryField,
    removeMissingMandatoryField,
  };

  return (
    <SharedCheckBoxInput
      {...props}
      formStateKey="autoPersonalForm"
      formActions={formActions}
    />
  );
};

export default AutoCheckBoxInput;
